import * as React from "react";
import {
  AppBar,
  Box,
  Button,
  Toolbar,
  Container,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  Avatar,
  useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import Logo from "../assets/Images/Logo.png";
import { useNavigate, useLocation } from "react-router-dom";

const navLinks = [
  { text: "Home", section: "home" },
  { text: "About", section: "about" },
  { text: "Services", section: "services" },
  { text: "DBS-Search", href: "/login" },
  { text: "Contact Us", section: "contact" },
];

const ResponsiveAppBar = ({ scrollToSection }) => {
  const isMobile = useMediaQuery("(max-width:768px)");
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const [user, setUser] = React.useState(null);

  const navigate = useNavigate();
  const location = useLocation();

  React.useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    } else {
      navigate("/login");
    }
  }, [navigate]);

  const handleMenuOpen = (event) => setAnchorElNav(event.currentTarget);
  const handleMenuClose = () => setAnchorElNav(null);

  const handleNavClick = (link) => {
    if (link.section) {
      if (location.pathname === "/") {
        scrollToSection && scrollToSection(link.section);
      } else {
        navigate(`/#${link.section}`);
      }
    } else if (link.href) {
      navigate(link.href);
    }
  };

  const handleUserMenuOpen = (event) => setAnchorElUser(event.currentTarget);
  const handleUserMenuClose = () => setAnchorElUser(null);

  const handleLogout = () => {
    localStorage.clear();
    setUser(null);
    navigate("/login");
  };

  return (
    <>
      <AppBar position="fixed" sx={{ bgcolor: "white", boxShadow: "none", paddingY: 1 }}>
        <Container maxWidth="xl">
          <Toolbar sx={{ justifyContent: "space-between" }}>
            {/* Logo */}
            <Typography
              variant="h5"
              noWrap
              component="a"
              href="/"
              sx={{
                display: "flex",
                alignItems: "center",
                textDecoration: "none",
              }}
            >
              <img
                alt="logo"
                src={Logo || "https://via.placeholder.com/100x50?text=Logo"}
                style={{ height: "50px", objectFit: "contain" }}
              />
            </Typography>

            {/* Desktop Navigation */}
            {!isMobile && (
              <Box sx={{ display: "flex", alignItems: "center" }}>
                {navLinks.map((link, index) => (
                  <Button
                    key={index}
                    onClick={(e) => {
                      e.preventDefault();
                      handleNavClick(link);
                    }}
                    sx={{
                      color: "#333",
                      fontWeight: 600,
                      textTransform: "none",
                      fontSize: "16px",
                      mx: 2,
                      "&:hover": { backgroundColor: "#b4d78d" },
                    }}
                  >
                    {link.text}
                  </Button>
                ))}

                {/* User name + avatar */}
                {user && (
                  <>
                    <Box
                      onClick={handleUserMenuOpen}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        ml: 2,
                      }}
                    >
                      <Avatar
                        sx={{
                          bgcolor: "#c6db8c",
                          mr: 1,
                        }}
                      >
                        {user.name ? user.name[0].toUpperCase() : "U"}
                      </Avatar>
                      <Typography sx={{ fontWeight: 500, color: "#333" }}>
                        {user.name}
                      </Typography>
                    </Box>
                    <Menu
                      anchorEl={anchorElUser}
                      open={Boolean(anchorElUser)}
                      onClose={handleUserMenuClose}
                    >
                      <MenuItem onClick={handleLogout}>Logout</MenuItem>
                    </Menu>
                  </>
                )}
              </Box>
            )}

            {/* Mobile Navigation */}
            {isMobile && (
              <Box sx={{ display: "flex", alignItems: "center" }}>
                {user && (
                  <>
                    <Box
                      onClick={handleUserMenuOpen}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        mr: 1,
                      }}
                    >
                      <Avatar sx={{ bgcolor: "#c6db8c", mr: 1 }}>
                        {user.name ? user.name[0].toUpperCase() : "U"}
                      </Avatar>
                      <Typography sx={{ fontWeight: 500, color: "#333" }}>
                        {user.name}
                      </Typography>
                    </Box>
                    <Menu
                      anchorEl={anchorElUser}
                      open={Boolean(anchorElUser)}
                      onClose={handleUserMenuClose}
                    >
                      <MenuItem onClick={handleLogout}>Logout</MenuItem>
                    </Menu>
                  </>
                )}

                <IconButton onClick={handleMenuOpen}>
                  <MenuIcon sx={{ color: "#333" }} />
                </IconButton>
                <Menu
                  anchorEl={anchorElNav}
                  open={Boolean(anchorElNav)}
                  onClose={handleMenuClose}
                  PaperProps={{
                    sx: { backgroundColor: "#c6db8c", minWidth: "150px" },
                  }}
                >
                  {navLinks.map((link, index) => (
                    <MenuItem
                      key={index}
                      onClick={() => {
                        handleMenuClose();
                        handleNavClick(link);
                      }}
                    >
                      {link.text}
                    </MenuItem>
                  ))}
                </Menu>
              </Box>
            )}
          </Toolbar>
        </Container>
      </AppBar>
      <Toolbar />
    </>
  );
};

export default ResponsiveAppBar;
